<template>
    <div>
        <breadcrumbs
            :title="'Administratori'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Administratori</h5><br>
                <button
                    type="button"
                    class="btn btn-lg btn-primary"
                    @click.prevent="create"
                >
                    Novi unos
                </button>
            </div>
            <div class="ibox-content">
                <datatables
                    v-if="show_datatable"
                    :url="datatables_url"
                    :settings="datatables.settings"
                    :title="datatables.title"
                    @rowClick="rowClick"
                >
                </datatables>
            </div>
        </div>
    </div>

</template>

<script>
import Datatables from "@/components/datatable/Datatables";
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";
import axios from "axios";

export default {
    name: "Administratori",
    components: {Breadcrumbs, Datatables},
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL +  'user',
            datatables: {},
            breadcrumbs: [],
        }

    },
    methods:{
        rowClick( row ){
            this.$router.push( { path: '/administratori/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/administratori/create' } )
        },

        setDatatable() {
            let vm = this;
            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,
                        },
                        {
                            'id': 'ime',
                            'title': 'Ime',
                            'column_visibility_group': {
                                id: 'user',
                            }
                        },
                        {
                            'id': 'prezime',
                            'title': 'Prezime',
                            'column_visibility_group': {
                                id: 'user',
                            }
                        },
                        {
                            'id': 'email',
                            'title': 'E-mail',
                            'column_visibility_group': {
                                id: 'user',
                            }
                        },
                        {
                            'id': 'username',
                            'title': 'Username',
                            'column_visibility_group': {
                                id: 'user',
                            }
                        },
                        {
                            'id': 'permission.name',
                            'title': 'Ovlasti',
                            'filter': {
                                'type': 'select',
                                'search': function ( ){
                                    let component = this;

                                    axios.get( process.env.VUE_APP_API_URL +  'user-permission')
                                        .then( function ( response ) {
                                            let tmp = [];
                                            response.data.data.forEach( function ( item ) {
                                                tmp.push({
                                                    key: item.id,
                                                    value: item.name
                                                } );
                                            } );
                                            component.$data.tmp = tmp;
                                        } )
                                        .catch( function ( error ) {
                                            if(error instanceof Error) {
                                                console.log( 'Error: ' . error);
                                            } else {
                                                console.log( 'Unexpected response: ' . error);
                                            }
                                        } )
                                },
                                'value': null
                            },
                            'column_visibility_group': {
                                id: 'user',
                            }
                        },

                    ],
                    column_visibility_groups:{
                        'user' : 'Administratori'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Administratori',
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/administratori',
                    name: 'Administratori'
                }
            ];
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>
